import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/utils.helpers";
import GoogleAuthButton from "../components/GoogleAuthButton";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await register(form.name, form.email, form.password);
      toast.success("Bienvenue chez Synergie !");
      navigate("/mon-compte");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-x py-20 max-w-md" data-testid="register-page">
      <p className="overline text-[#2B8B8E]">Inscription</p>
      <h1 className="text-4xl font-light mt-2 mb-8">Rejoignez Synergie.</h1>
      <form onSubmit={submit} className="space-y-4 border border-border rounded-3xl p-7 bg-card">
        <GoogleAuthButton label="S'inscrire avec Google" testId="register-google-btn" />
        <div className="relative flex items-center py-1">
          <div className="flex-grow border-t border-border"></div>
          <span className="mx-3 text-[10px] uppercase tracking-widest text-muted-foreground">ou</span>
          <div className="flex-grow border-t border-border"></div>
        </div>
        <div>
          <Label>Nom complet</Label>
          <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="register-name" />
        </div>
        <div>
          <Label>Email</Label>
          <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email" />
        </div>
        <div>
          <Label>Mot de passe</Label>
          <Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password" />
        </div>
        <Button type="submit" disabled={submitting} className="w-full bg-[#2B8B8E] hover:bg-[#1F6F73] text-white rounded-full" data-testid="register-submit">
          {submitting ? "Création…" : "Créer mon compte"}
        </Button>
        <p className="text-xs text-center text-muted-foreground">
          Déjà inscrit ? <Link to="/connexion" className="text-[#2B8B8E] hover:underline">Se connecter</Link>
        </p>
      </form>
    </div>
  );
}
